import { createAwayScheduleBlockV2 } from '@/services/createAwayScheduleBlockV2';
import { fetchClient } from '@/util/fetchClient';

type DateRange = { startDate: string; endDate: string };

/**
 * Saves the expert's single away period: creates it when none exists, or changes
 * the shown block in place with one PUT. It must stay one request, so a failed
 * change can never leave the expert with no period at all. The server decides
 * what an edit may do.
 */
export async function replaceAwayPeriodV2({
  previous,
  next,
}: {
  previous?: { id: number };
  next: DateRange;
}) {
  if (!previous) {
    return createAwayScheduleBlockV2(next);
  }

  const { data } = await fetchClient.PUT('/v2/users/me/away-schedule/{id}', {
    params: { path: { id: previous.id } },
    body: { startDate: next.startDate, endDate: next.endDate },
  });

  return data?.data;
}
